import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const LoginGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const loggedIn = authService.isAuthenticated();

  if (loggedIn) {
    return router.navigate(['/p/home']);
  }

  return true;
};
